import React, { useState } from 'react';
import { useReveal } from '../hooks/useReveal';
export function ContactForm() {
  const headerRef = useReveal();
  const revealRef = useReveal<HTMLFormElement>();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    stakeholder: '',
    message: ''
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = formData.name.trim() && formData.email.trim() && emailRegex.test(formData.email) && formData.stakeholder;
    if (isValid) {
      setSuccess(true);
      setError(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        stakeholder: '',
        message: ''
      });
    } else {
      setError(true);
      setSuccess(false);
    }
  };
  const labelClass = 'block text-sm font-semibold text-ink/80 mb-1.5';
  const inputClass = 'w-full bg-white rounded-full px-5 py-3 text-sm text-ink placeholder-ink/35 shadow-sm focus:outline-none focus:ring-2 focus:ring-gold';
  return <section id="contact" className="bg-white py-12 lg:py-20 scroll-mt-24" data-id="element-45">
      <div className="mx-3 sm:mx-6 rounded-[40px] bg-paperdeep border border-line py-16 lg:py-20 relative overflow-hidden shadow-md" data-id="element-46">
        <svg className="absolute right-0 top-0 opacity-[0.08] pointer-events-none hidden sm:block" width="260" height="200" viewBox="0 0 260 200" fill="none" stroke="#5C6A37" strokeWidth="1.4" aria-hidden="true" data-id="element-47">
          <path d="M250 0c-14 22-36 32-58 26-24-7-37-30-30-53" data-id="element-48" />
          <ellipse cx="195" cy="25" rx="26" ry="36" transform="rotate(150 195 25)" data-id="element-49" />
          <ellipse cx="230" cy="-15" rx="20" ry="28" transform="rotate(170 230 -15)" data-id="element-50" />
          <circle cx="150" cy="55" r="16" data-id="element-51" />
          <circle cx="175" cy="35" r="11" data-id="element-52" />
        </svg>

        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center relative" data-id="element-53">
          <div ref={headerRef} className="reveal flex flex-col items-center" data-id="element-54">
            <span className="eyebrow text-forest mb-3" data-id="element-55">Talk To AFEXA</span>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold text-ink mt-6" data-id="element-56">
              Tell us where you fit in
            </h2>
            <p className="mt-4 text-ink/70 leading-relaxed" data-id="element-57">
              We'll tailor the conversation to your role in the value chain —
              and follow up directly.
            </p>
          </div>

          <form ref={revealRef} onSubmit={handleSubmit} className="mt-10 reveal text-left space-y-4" data-id="element-58">
            <span className="receipt-serial block text-ink/50 text-center mb-2" data-id="element-59">
              AFEXA‑LEAD‑CONTACT
            </span>

            <div className="grid sm:grid-cols-2 gap-4" data-id="element-60">
              <div data-id="element-61">
                <label className={labelClass} htmlFor="cf-name" data-id="element-62">
                  Full name *
                </label>
                <input id="cf-name" type="text" required value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className={inputClass} data-id="element-63" />
              </div>
              <div data-id="element-64">
                <label className={labelClass} htmlFor="cf-email" data-id="element-65">
                  Email *
                </label>
                <input id="cf-email" type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className={inputClass} data-id="element-66" />
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4" data-id="element-67">
              <div data-id="element-68">
                <label className={labelClass} htmlFor="cf-phone" data-id="element-69">
                  Phone
                </label>
                <input id="cf-phone" type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className={inputClass} data-id="element-70" />
              </div>
              <div data-id="element-71">
                <label className={labelClass} htmlFor="cf-type" data-id="element-72">
                  I represent... *
                </label>
                <select id="cf-type" required value={formData.stakeholder} onChange={e => setFormData({
                ...formData,
                stakeholder: e.target.value
              })} className="w-full bg-white rounded-full px-5 py-3 text-sm text-ink shadow-sm focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-73">
                  <option value="" data-id="element-74">Select one</option>
                  <option data-id="element-75">Farmer / Farmer Group</option>
                  <option data-id="element-76">Buyer</option>
                  <option data-id="element-77">Bank / MFI</option>
                  <option data-id="element-78">Cooperative</option>
                  <option data-id="element-79">Exporter</option>
                  <option data-id="element-80">Government / Regulator</option>
                </select>
              </div>
            </div>

            <div data-id="element-81">
              <label className={labelClass} htmlFor="cf-msg" data-id="element-82">
                What would you like to know?
              </label>
              <textarea id="cf-msg" rows={3} value={formData.message} onChange={e => setFormData({
              ...formData,
              message: e.target.value
            })} className="w-full bg-white rounded-3xl px-5 py-3.5 text-sm text-ink placeholder-ink/35 shadow-sm focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-83" />
            </div>

            <button type="submit" className="btn-pill w-full justify-center bg-forestdeep hover:bg-forest text-paper py-3.5" data-id="element-84">
              Send Message
            </button>

            {success && <p className="text-sm text-forestdeep font-semibold pt-1 text-center" data-id="element-85">
                Thanks — we've received your message and will be in touch.
              </p>}
            {error && <p className="text-sm text-terracotta font-semibold pt-1 text-center" data-id="element-86">
                Please complete the required fields with a valid email address.
              </p>}
          </form>
        </div>
      </div>
    </section>;
}